import { render, staticRenderFns } from "./AlertRSActionsTable.vue?vue&type=template&id=4da00d6c&scoped=true&"
import script from "./AlertRSActionsTable.vue?vue&type=script&lang=js&"
export * from "./AlertRSActionsTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertRSActionsTable.vue?vue&type=style&index=0&id=4da00d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da00d6c",
  null
  
)

export default component.exports